export default "__VITE_ASSET__GKVTw8jv__"